import { apiService } from './apiService'
import { onboardingEndpoints } from '@/api/apiEndpoint'

export interface OnboardingInfoProps {
  id: number;
  name: string;
  businessNumber: string;
  ceoName: string;
  ceoEmail: string;
  invitedName: string[];
  invitedEmail: string[];
  logo?: string;
  investor: string;
  onboardingStatus: 'NOT_STARTED' | 'DOCUMENT' | 'EMPLOYEE' | 'STAKEHOLDER' | 'STOCK_CAPITAL_HISTORY' | 'COMPLETED';
}

export const onboardingService = {
  async getOnboardingInfo(
    notificationId: string
  ): Promise<OnboardingInfoProps | null> {
    try {
      const response = await apiService.get<OnboardingInfoProps>(
        onboardingEndpoints.getOnboardingInfo(notificationId)
      )
      return response;
    } catch (err: any) {
      console.error(err)
      return null
    }
  },
}